/* globals serverParams */
import { normalizeAccents } from 'bam-node-baseball-savant/utils/normalize-accents'

const isPlayer = new Set(['batter', 'pitcher', 'catcher', 'fielder']).has(
    serverParams.type
)
const isTeam = new Set([
    'batting-team',
    'pitching-team',
    'catching-team',
    'fielding-team',
]).has(serverParams.type)

// Needs to take augmentedRow data (more meaning that player entity_id needs to be formatted as 'id')
export function playerDisplayFn(name, d) {
    const isCatcher = serverParams ? serverParams.type === 'catcher' : false

    // If league average -> show MLB logo -> no link -> image as placeholder size
    if (d.pinned) {
        const imageHtml = isPlayer
            ? `
                <img
                    class="player-mug"
                    src="https://content.mlb.com/images/headshots/current/60x60/999999.png"
                    style="visibility: hidden"
                />
            `
            : ''
        return `${imageHtml} ${name}`
    }
    // If batter/pitcher -> show image -> link player
    if (isPlayer) {
        const imageHtml = `
                <img
                    class="player-mug"
                    height="60"
                    width="60"
                    onError="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';"
                    src="https://content.mlb.com/images/headshots/current/60x60/${d.id}.png"
                />
            `

        return `${imageHtml} <a href="/savant-player/${d.id}?stats=${
            isCatcher
                ? 'statcast-r-catching-mlb'
                : 'statcast-r-bat_tracking-mlb#statcast_bat_tracking'
        }" target="_blank">${name}</a>`
    }

    // If team -> No Image -> link team
    if (isTeam) {
        return `<a href="/team/${d.id}" target="_blank">${name}</a>`
    }

    return name
}

export function playerDisplayFnByIdLink(name, id, link, params = {}) {
    let formattedName = name
    if (params.firstInit) {
        const [lastName, firstName] = formattedName.split(', ')
        const firstInit = firstName[0]
        formattedName = `${lastName}, ${firstInit}.`
    }

    if (params.chalFormat) {
        const className = `abs-badge-${
            params.chalSuccess ? 'successful' : 'unsuccessful'
        }-player`
        formattedName = `<span class="${className} abs-badge-player-leaderboard">${formattedName}</span>`
    }

    const imageHtml = `
                <img
                    class="player-mug"
                    height="60"
                    width="60"
                    onError="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';"
                    src="https://content.mlb.com/images/headshots/current/60x60/${id}.png"
                />
            `

    return `${imageHtml} <a href="/savant-player/${id}${link}" target="_blank">${formattedName}</a>`
}

export function playerDisplayFnById(name, id, params = {}) {
    let formattedName = name
    if (params.firstInit) {
        const [lastName, firstName] = formattedName.split(', ')
        const firstInit = firstName[0]
        formattedName = `${lastName}, ${firstInit}.`
    }

    if (params.chalFormat) {
        const className = `abs-badge-${
            params.chalSuccess ? 'successful' : 'unsuccessful'
        }-player`
        formattedName = `<span class="${className} abs-badge-player-leaderboard">${formattedName}</span>`
    }

    const imageHtml = `
                <img
                    class="player-mug"
                    height="60"
                    width="60"
                    onError="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';"
                    src="https://content.mlb.com/images/headshots/current/60x60/${id}.png"
                />
            `

    return `${imageHtml} <a href="/savant-player/${id}?stats=statcast-r-bat_tracking-mlb#statcast_bat_tracking" target="_blank">${formattedName}</a>`
}

export function teamDisplayFnWithLogo(name, id, params = {}) {
    const imageHtml = `
                <img
                    class="${
                        params.padding
                            ? 'table-team-logo-big'
                            : 'table-team-logo'
                    }"
                    height="60"
                    width="60"
                    ${params.padding ? 'style="padding: 6px;"' : ''}
                    onError="this.onerror=null;this.src='/site-core/images/savant-mlb.svg';"
                    src="https://www.mlbstatic.com/team-logos/${id}.svg"
                />
            `

    return `${imageHtml}${params.showName ? ` ${name}` : ''}`
}

export function getFilteredData(data, search) {
    const normalized_search = normalizeAccents(search)

    return data.filter((d) => {
        const name = normalizeAccents(d.name)

        return (
            name.includes(normalized_search) ||
            Number(d.id) === Number(normalized_search)
        )
    })
}

export const playerDisplayFnFactory = (url) =>
    function playerDisplayFnFactoryBase(name, d) {
        // If league average -> show MLB logo -> no link
        if (d.pinned) {
            const imageHtml = isPlayer
                ? `<img
                    class="player-mug"
                    src="https://content.mlb.com/images/headshots/current/60x60/999999.png"
                    style="visibility: hidden"
                    />`
                : ''
            return `${imageHtml} ${name}`
        }

        // If batter/pitcher -> show image -> link player
        if (isPlayer) {
            const imageHtml = `
                <img
                    class="player-mug"
                    height="60"
                    width="60"
                    onError="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';"
                    src="https://content.mlb.com/images/headshots/current/60x60/${d.id}.png"
                />
            `

            return `${imageHtml} <a href="/savant-player/${d.id}${url}" target="_blank">${name}</a>`
        }

        // If team -> No Image -> link team
        if (isTeam) {
            return `<a href="/team/${d.id}" target="_blank">${name}</a>`
        }

        return name
    }
